var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewFolderIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder settings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6772 16.0454H1.99997C1.92087 16.0454 1.84641 16.0081 1.79929 15.9443C1.75217 15.8809 1.73776 15.7988 1.76071 15.7229L4.08615 8.03687C4.11813 7.9314 4.2153 7.85938 4.32541 7.85938H18C18.0791 7.85938 18.1535 7.89673 18.2007 7.96045C18.2478 8.02393 18.2622 8.10596 18.2392 8.18164L15.9165 15.8677C15.8847 15.9731 15.7873 16.0454 15.6772 16.0454ZM2.33688 15.5454H15.4917L17.6633 8.35938H4.51096L2.33688 15.5454Z",
    fill: "#F7B84B",
    stroke: "#F7B84B",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.00024 16.0432C1.98804 16.0432 1.97583 16.0422 1.96338 16.0405C1.84082 16.0225 1.75 15.9172 1.75 15.7932V4.20312C1.75 4.06494 1.86182 3.95312 2 3.95312H6.64233C6.72876 3.95312 6.80884 3.9978 6.85449 4.07104L7.88135 5.7207H15.6748C15.813 5.7207 15.9248 5.83252 15.9248 5.9707V8.10571C15.9248 8.2439 15.813 8.35571 15.6748 8.35571H4.5105L2.23926 15.8655C2.20703 15.9722 2.10889 16.0432 2.00024 16.0432ZM2.25 4.45312V14.103L4.08569 8.03345C4.11768 7.92798 4.21484 7.85571 4.32495 7.85571H15.4248V6.2207H7.74243C7.65601 6.2207 7.57593 6.17603 7.53027 6.10278L6.50342 4.45312H2.25Z",
    fill: "#F7B84B",
    stroke: "#F7B84B",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFolderIcon);
export default __webpack_public_path__ + "static/media/NewFolderIcon.abb0a75b8bf50ac30816b7112ec53728.svg";
export { ForwardRef as ReactComponent };